var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaryellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4612 0C16.0003 0 16.4924 0.304664 16.7268 0.790956L20.746 9.06963L29.7219 10.3937C30.2492 10.4699 30.6886 10.839 30.8527 11.3488C31.0167 11.8585 30.882 12.4092 30.507 12.7842L23.9977 19.2407L25.5327 28.3572C25.6206 28.8845 25.4039 29.4177 24.9644 29.7341C24.525 30.0505 23.9508 30.0856 23.4821 29.8337L15.4554 25.5449L7.44037 29.8278C6.96579 30.0798 6.39162 30.0446 5.95806 29.7282C5.5245 29.4118 5.30186 28.8787 5.38974 28.3514L6.92478 19.2349L0.415506 12.7842C0.0346753 12.4092 -0.0942212 11.8526 0.0698289 11.3488C0.233879 10.8449 0.673299 10.4758 1.2006 10.3937L10.1765 9.06963L14.1957 0.790956C14.4359 0.304664 14.9222 0 15.4612 0ZM15.4612 4.62856L12.3853 10.9679C12.1802 11.3839 11.7877 11.6769 11.3248 11.7472L4.39372 12.7666L9.42654 17.7526C9.74879 18.0748 9.90112 18.5318 9.82495 18.9829L8.63559 25.9961L14.7992 22.7034C15.2152 22.4807 15.7132 22.4807 16.1233 22.7034L22.2869 25.9961L21.1034 18.9888C21.0272 18.5377 21.1737 18.0807 21.5018 17.7584L26.5346 12.7725L19.6035 11.7472C19.1465 11.6769 18.7481 11.3898 18.543 10.9679L15.4612 4.62856Z",
    fill: "#FFCD05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaryellow);
export default __webpack_public_path__ + "static/media/star yellow.e24dca45031b2a16eb88a7e363a5fbb5.svg";
export { ForwardRef as ReactComponent };